module.exports = __webpack_public_path__ + "static/media/24.d7d9e3d5.mp3";